function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Box from './Box';
import Flex from './Flex';
import ListGroup from './ListGroup';
import ListGroupItem from './ListGroupItem';
const ListGroupMenu = /*#__PURE__*/memo(_ref => {
  let {
    items,
    borderRadius,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ListGroup, {
    borderRadius: borderRadius
  }, items && items.map((item, i) => /*#__PURE__*/React.createElement(ListGroupMenuItem, _extends({
    key: i,
    item: item
  }, props))));
});
const ListGroupMenuItem = _ref2 => {
  let {
    item,
    ...props
  } = _ref2;
  if (typeof item === 'string') {
    return /*#__PURE__*/React.createElement(ListGroupItem, props, item);
  }
  const {
    label,
    icon,
    ...itemProps
  } = item;
  return /*#__PURE__*/React.createElement(ListGroupItem, _extends({}, props, itemProps), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: "1 1 auto"
  }, label), icon));
};
ListGroupMenu.propTypes = {
  ...Flex.propTypes,
  items: PropTypes.array.isRequired
};
ListGroupMenu.defaultProps = {};
ListGroupMenu.displayName = 'ListGroupMenu';
export default ListGroupMenu;